import { canStaffSection, showDepartmentNavigation } from './staffAccess';

export function communityNavigation({ base, tenantId, user, role, enabled }) {
  const admin = ['cip_admin', 'cip_staff'].includes(user?.globalRole) || role === 'community_admin';
  const staff = (section) => admin || canStaffSection(user, tenantId, section);
  const show = (section) => showDepartmentNavigation(user, tenantId, role, section);
  return [
    { to: `${base}/dashboard`, label: 'Community home' },
    enabled('harvesting') && { label: 'Harvesting', children: [
      { to: `${base}/harvesting?mode=contribute`, label: 'Log my harvest' },
      staff('harvesting') && { to: `${base}/harvesting`, label: 'Harvest support & data quality' },
      staff('harvesting') && { to: `${base}/harvesting-setup`, label: 'Harvest Setup' },
    ].filter(Boolean) },
    enabled('harvesting') && staff('stewardship') && { label: 'Stewardship', children: [
      { to: `${base}/stewardship`, label: 'Stewardship Plan' },
      { to: `${base}/species`, label: 'Species Catalog' },
    ] },
    staff('consultation') && show('consultation') && enabled('consultation') && { to: `${base}/consultation`, label: 'Consultation' },
    show('communityData') && enabled('communityData') && { to: `${base}/community-data`, label: 'Community Data' },
    show('communityNews') && enabled('communityNews') && { to: `${base}/community-news`, label: 'Community News' },
    show('landValues') && enabled('landValues') && { to: `${base}/land-values`, label: 'Land Values' },
    show('landUnits') && enabled('landUnits') && { to: `${base}/land-units`, label: 'Land Units' },
    admin && { label: 'Community Admin', children: [
      { to: `${base}/community-admin`, label: 'Community settings & people' },
      { to: `${base}/community-admin?tab=geography`, label: 'Map source layers' },
      { to: `${base}/community-admin?tab=traditional`, label: 'Traditional Lands' },
    ] },
  ].filter(Boolean);
}

export function membershipNavigation(membership, user) {
  const tenantId = typeof membership.tenantId === 'object' ? membership.tenantId?._id : membership.tenantId;
  return communityNavigation({
    base: `/t/${membership.tenantSlug || membership.tenantId?.slug}`,
    tenantId, user, role: membership.communityRole,
    enabled: (module) => membership.allowedModules?.[module] === true,
  });
}
